import { Button } from "components/DesignSystem/Button/Button";
import { NotePencil } from "components/icons/NotePencil";
import { UnifyNotes } from "components/Notes/UnifyNotes";
import { useModal } from "hooks/useModal";
import { useToast } from "hooks/useToast";
import ToolTip from "components/design/toolTip";
import {
  groupNotesResponse,
  Note,
  useAddGroupNotesMutation,
  useGroupNotesQuery,
  useLazyGroupNotesQuery,
} from "store/apis/notes";
import { BackendError } from "types/utils/error";
import { useEffect, useState } from "react";
import { usePaginatedQuery } from "hooks/usePaginatedQuery";
import { NOTE_TYPE } from "constants/unifyNotes";

export const GroupNote = ({
  groupId,
  countVisibility = true,
  currentNoteLabel = "Notes for this group",
  allNotesCount,
  className = "t-min-w-14",
}: {
  groupId: string;
  countVisibility?: boolean;
  currentNoteLabel?: string;
  allNotesCount?: number;
  className?: string;
}) => {
  const notedModal = useModal();

  return (
    <div onClick={(e) => e.stopPropagation()} className={className}>
      <Button
        size="xsmall"
        customType="ghost"
        onClick={(e) => {
          e.stopPropagation();
          notedModal.open();
        }}
      >
        <ToolTip text="Notes">
          <div className="t-flex gap-2 t-items-center">
            <NotePencil />
            {countVisibility && (allNotesCount ?? 0) > 0 && (
              <span
                className="t-text-subtext t-text-text-60"
                style={{ marginLeft: "0px" }}
              >
                {allNotesCount}
              </span>
            )}
          </div>
        </ToolTip>
      </Button>
      {notedModal.isOpen && (
        <UnifyNotes
          groupId={groupId}
          isOpen={notedModal.isOpen}
          close={notedModal.close}
          currentNoteLabel={currentNoteLabel}
          currentNoteType={NOTE_TYPE.GROUP}
          currentNoteTypeId={groupId}
        />
      )}
    </div>
  );
};
